import { Controller } from "stimulus";

export default class extends Controller {

  click() {
    $('.tox-dialog__footer-end button:first-child').click();
  }
}